import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';

import { CheckboxOptionsComponent } from './checkbox-options/checkbox-options.component';
import { PriceSliderComponent } from './price-slider/price-slider.component';
import { VehiclePositionSelectionComponent } from './vehicle-position-selection/vehicle-position-selection.component';
import { AccordionModule } from 'primeng/accordion';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { Collection, ManagedFilter } from '../../../graphql/generated/generated-types';
import { IMultiValueFilterParams, IShopParams } from '../../../routes/shop/shop.component';
import { Observable, Subject, of, takeUntil } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { IDropdownSelect } from '../form/dropdown-control/dropdown-control.component';
import { NotAvailableOverlayComponent } from '../not-available-overlay/not-available-overlay.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { isEqual } from 'lodash-es';
import { CheckboxControlComponent } from '../form/checkbox-control/checkbox-control.component';
import { EditableManagedFilter } from '../../../routes/shop/managed-filter.class';
import { QuickFiltersComponent } from '../quick-filters/quick-filters.component';
import { BootstrapGridBreakpoints, BreakpointsService } from '../../services/breakpoints.service';


@Component({
  selector: 'app-shop-filters',
  standalone: true,
  imports: [CommonModule, CheckboxOptionsComponent, PriceSliderComponent, VehiclePositionSelectionComponent,
    AccordionModule, RippleModule, NotAvailableOverlayComponent, ProgressSpinnerModule, CheckboxControlComponent, QuickFiltersComponent],
  templateUrl: './shop-filters.component.html',
  styleUrl: './shop-filters.component.scss'
})
export class ShopFiltersComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChildren(CheckboxOptionsComponent) checkboxOptionComponents!: QueryList<CheckboxOptionsComponent>;

  @Output() closeSidebar: EventEmitter<any> = new EventEmitter<any>();
  public manufacturersSearchControl: FormControl = new FormControl();
  @Input() sidebar: boolean = false;
  @Input() stickyToTop: boolean = false;
  @Input() collection!: Collection;
  @Input() leftFilters: EditableManagedFilter[];
  @Input() topFilters: EditableManagedFilter[];
  @Input() totalResults = 0;
  @Input() activeLeftFilters: IMultiValueFilterParams;
  @Input() activeQuickFilters: IMultiValueFilterParams;
  @Input() loading$: Observable<boolean> = of(false);
  @Input() initialLoading!: boolean;


  public filterOptions: { [key: string]: any } = {};
  public filterControls: FormGroup = new FormGroup({});
  public facetsQueryParams$: Observable<any | string[]>;

  private unsubscribeFormControlTrigger$: Subject<void> = new Subject<void>();
  private unsubscribeGlobal$: Subject<void> = new Subject<void>();

  public previousControlValues!: any;

  public onlyAvailableControl: FormControl = new FormControl(false);

  public smLayout: boolean;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private breakpointsService: BreakpointsService
  ) {}

  ngOnInit(): void {
    this.subscribeToSmLayout();
    this.subscribeToOnlyAvailableControlChanges();
    if (this.loading$) {
      this.subscribeToLoadingChanges();
    }
  }

  private subscribeToSmLayout(){
    this.breakpointsService.isBreakpointOrLower(BootstrapGridBreakpoints.SMlabel).pipe(takeUntil(this.unsubscribeGlobal$)).subscribe(
      {
        next: (matches: boolean) => {
          this.smLayout = matches;
        }
      }
    )
  }

  private subscribeToOnlyAvailableControlChanges() {
    this.onlyAvailableControl.valueChanges.pipe(takeUntil(this.unsubscribeGlobal$)).subscribe(value => {
      if (value) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParamsHandling: 'merge',
          queryParams: { page: null, search: null, inStock: true } as IShopParams,
          state: {
            noScroll: true,
          },
        } as NavigationExtras);
      } else {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParamsHandling: 'merge',
          queryParams: { page: null, search: null, inStock: null } as IShopParams,
          state: {
            noScroll: true,
          },
        } as NavigationExtras);
      }

    })
  }
  private subscribeToLoadingChanges() {
    this.loading$.pipe(takeUntil(this.unsubscribeGlobal$)).subscribe(loading => {

      if (loading) {
        this.filterControls.disable({ emitEvent: false });
      } else {
        this.filterControls.enable({ emitEvent: false });
      }
    })
  }




  ngOnChanges(changes: SimpleChanges): void {
    if ('leftFilters' in changes) {
      this.resetFormControlSubscription();
      this.generateEntryFilterControls();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeFormControlTrigger$.next();
    this.unsubscribeFormControlTrigger$.complete();
    this.unsubscribeGlobal$.next();
    this.unsubscribeGlobal$.complete();
  }

  private resetFormControlSubscription() {
    this.unsubscribeFormControlTrigger$.next();
  }



  public clearFiltersWithoutRoute() {
    this.checkboxOptionComponents.forEach((checkboxOption: CheckboxOptionsComponent) => {
      checkboxOption.resetAllValues();
    })
    this.filterControls.reset(null, { emitEvent: false });
  }


  public clearFilters() {
    if(this.smLayout){
      this.router.navigate([], {
        relativeTo: this.route,
        queryParamsHandling: 'merge',
        queryParams: { quickFilters: null, filters: null, page: null, search: null, lf: null } as IShopParams,
        state: {
          noScroll: true,
        },
      });
    } else {
      this.checkboxOptionComponents.forEach((checkboxOption: CheckboxOptionsComponent) => {
        checkboxOption.resetAllValues();
      })
      this.filterControls.reset(null, { emitEvent: false });
      this.router.navigate([], {
        relativeTo: this.route,
        queryParamsHandling: 'merge',
        queryParams: { filters: null, search: null, page: null, lf: null } as IShopParams,
        state: {
          noScroll: true,
        },
      } as NavigationExtras);
    }

  }

  public subscribeToControlChanges(): void {
    this.filterControls.valueChanges.pipe(
      takeUntil(this.unsubscribeFormControlTrigger$)
    ).subscribe({
      next: (values) => {
        if (!isEqual(this.previousControlValues, values)) {
          this.previousControlValues = values;
          const leftFilters: IMultiValueFilterParams = { ...this.activeLeftFilters }; // Copy existing activeLeftFilters
          for (const key in values) {
            if (values.hasOwnProperty(key)) {
              const value = values[key];
              const numKey = parseInt(key, 10); // Parse key as a number


              if (value !== null && Array.isArray(value) && value.length > 0) {
                leftFilters[numKey] = value;
              } else {
                delete leftFilters[numKey];
              }
            }
          }

          const queryParamsNew: IShopParams = {
            filters: this.convertToQueryParamString(leftFilters),
            page: null
          };
          this.updateQueryParams(queryParamsNew);
        }
      },
      complete: () => { }
    });
  }

  private updateQueryParams(queryParamsNew: IShopParams): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParamsNew as IShopParams,
      queryParamsHandling: 'merge',
      state: {
        noScroll: true,
      },
    });
  }

  private convertToQueryParamString(params: IMultiValueFilterParams): string | null {
    // Check if the params object is empty
    if (Object.keys(params).length === 0) {
      return null;
    }
    return Object.entries(params)
      .map(([key, values]) => `${key}:${values.join(';')}`)
      .join(',');
  }



  public generateEntryFilterControls() {
    const formGroupControls: { [key: string]: any } = {};
    if (this.leftFilters && this.leftFilters?.length > 0) {
      for (const filter of this.leftFilters) {
        const filterOptions: IDropdownSelect[] = [];
        for (const filterValue of filter.values) {
          filterOptions.push({
            value: filterValue.id,
            label: filterValue.name,
            count: filterValue.count
          });
        }

        this.filterOptions[filter.id] = filterOptions;
        formGroupControls[filter.id] = [undefined];

      }
      this.filterControls = this.formBuilder.group(formGroupControls);

      for (const filterId in this.filterOptions) {
        if (this.filterOptions.hasOwnProperty(filterId)) {
          const filterOptions = this.filterOptions[filterId];
          for (const option of filterOptions) {
            for (const key in this.activeLeftFilters) {
              for (const child in this.activeLeftFilters[key]) {
                if (this.activeLeftFilters.hasOwnProperty(key) && this.activeLeftFilters[key][child] === option.value) {
                  const control = this.filterControls.get(filterId);

                  if (control) {
                    const currentValue = control.value;
                    if (Array.isArray(currentValue)) {

                      // If it's already an array, append option.value to it
                      const updatedValue = [...currentValue, option.value];
                      control.setValue(updatedValue, { emitEvent: false });

                    } else {
                      // If it's not an array, create a new array with both values
                      control.setValue([option.value], { emitEvent: false });

                    }
                  }
                  break;
                }
              }

            }
          }
        }
      }
      this.subscribeToControlChanges();
      this.filterControls.disable({ emitEvent: false });
    }
  }



  public closeFiltersSidebar() {
    this.closeSidebar.emit();
  }


}
